import React from 'react'
import { createBrowserHistory } from 'history'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

const BackButton = ({ style }) => {
  const history = createBrowserHistory()

  return (
    <button
      type="button"
      style={style.button}
      onClick={() => history.back()}
      className="btn btn-primary custom-btn-payment">
      Tillbaka
    </button>
  )
}

const AbortButton = ({ style, url, clickAction }) => {
  if (clickAction !== undefined) {
    return (
      <Link
        onClick={clickAction}
        style={style.button}
        to={'/' + url}
        className="btn btn-primary custom-btn-payment">
        Avbryt
      </Link>
    )
  }

  return (
    <Link
      style={style.button}
      to={'/' + url}
      className="btn btn-primary custom-btn-payment">
      Avbryt
    </Link>
  )
}

BackButton.propTypes = {
  style: PropTypes.object.isRequired
}

AbortButton.propTypes = {
  style: PropTypes.object.isRequired,
  url: PropTypes.string.isRequired,
  clickAction: PropTypes.func
}

export { BackButton, AbortButton }
